export class ManualsMappingDto {
  id: number | null;
  pathKeyword: string;
  manualLink: string;
}
